<template>
  <div>
    <p class="text-rigth mt-4 texto-color">CARGA DE CESEs (MASIVO)</p>

    <div class="mx-2">
      <div class="card border-info pb-4 pt-2 mx-3 text-left">
        <h4 class="tituloColor mx-3 mt-2">Opciones:</h4>
        <div class="row mx-2">
          <button class="btn btn-secondary col col-3" @click="CargaTrabajadores">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor"
              class="bi bi-database-up mx-1" viewBox="0 0 16 16">
              <path
                d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0Z" />
              <path
                d="M12.096 6.223A4.92 4.92 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.493 4.493 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.525 4.525 0 0 1-.813-.927C8.5 14.992 8.252 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.552 4.552 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10c.262 0 .52-.008.774-.024a4.525 4.525 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777ZM3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4Z" />
            </svg>
            CARGA DE TRABAJADORES
          </button>

          <div class="col col-7 align-self-center">
            Opción para cargar trabajadores que pasarán por una nueva renovación
          </div>

          <!-- <button class="btn btn-danger mt-3 col col-3" @click="quitarCampos()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              fill="currentColor"
              class="bi bi-unlock mx-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"
              /></svg
            >DESBLOQUEO MASIVO
          </button> -->

          <!-- <div class="col col-7 mt-3 align-self-center">
            Opción para desbloquear el listado de trabajadores cuando ya se esta
            realizando una renovación MASIVA
          </div> -->

          <button class="btn btn-success mt-3 col col-3" @click="$router.push('/RegistroCeseInd')">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-person mx-2"
              viewBox="0 0 16 16">
              <path
                d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
            </svg>INDIVIDUAL
          </button>

          <div class="col col-7 mt-3 align-self-center">
            Opción para ir a una renovación INDIVIDUAL de trabajadores
          </div>

          <button @click="descargarExcel" :class="{
            'btn btn-success border-dark border-2  tamaño mt-3 ms-1 col col-3 text-white text-nowrap':
              !excelCarga,
            'btn btn-ligth border-dark border-2 tamaño mt-3 ms-1 col col-3 text-success  text-nowrap':
              excelCarga,
          }" :disabled="!excelCarga">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor"
              class="bi bi-filetype-xls" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM6.472 15.29a1.176 1.176 0 0 1-.111-.449h.765a.578.578 0 0 0 .254.384c.07.049.154.087.25.114.095.028.202.041.319.041.164 0 .302-.023.413-.07a.559.559 0 0 0 .255-.193.507.507 0 0 0 .085-.29.387.387 0 0 0-.153-.326c-.101-.08-.255-.144-.462-.193l-.619-.143a1.72 1.72 0 0 1-.539-.214 1.001 1.001 0 0 1-.351-.367 1.068 1.068 0 0 1-.123-.524c0-.244.063-.457.19-.639.127-.181.303-.322.527-.422.225-.1.484-.149.777-.149.305 0 .564.05.78.152.216.102.383.239.5.41.12.17.186.359.2.566h-.75a.56.56 0 0 0-.12-.258.625.625 0 0 0-.247-.181.923.923 0 0 0-.369-.068c-.217 0-.388.05-.513.152a.472.472 0 0 0-.184.384c0 .121.048.22.143.3a.97.97 0 0 0 .405.175l.62.143c.217.05.406.12.566.211a1 1 0 0 1 .375.358c.09.148.135.335.135.56 0 .247-.063.466-.188.656a1.216 1.216 0 0 1-.539.439c-.234.105-.52.158-.858.158-.254 0-.476-.03-.665-.09a1.404 1.404 0 0 1-.478-.252 1.13 1.13 0 0 1-.29-.375Zm-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94l1.274-2.007Zm2.727 3.325H4.557v-3.325h-.79v4h2.487v-.675Z" />
            </svg>
            <b v-if="excelCarga">Descargar Lista </b>
            <b v-else>Cargando...</b>
          </button>

          <div class="mt-3">
            <p class="mx-1 mt-2">
              Las opciones presentadas acontinuación pueden ser llenadas en su
              totalidad si los trabajadores escogidos o marcados cumplen con las
              mismas características(Puesto, Sueldo, Fec. Fin) en una
              renovación.De ser el caso que estas características sean distintas
              no deben de ser llenadas.
            </p>

            <div class="row gx-3 gy-4">
              <div class="col-3">
                <label for="">Empresa</label>
                <select class="form-control text-center py-1" @change="CentroCostoMasivo($event)" disabled>
                  <option disabled selected>-</option>
                  <option v-for="empresa in DniEmpre" :key="empresa.id" :value="empresa.id">
                    {{ empresa.empNomCorto }}
                  </option>
                </select>
              </div>

              <div class="col-3">
                <label for="">Centro Costo</label>
                <select class="form-control text-center py-1" @change="SubCentroCostoMasivo($event)" disabled>
                  <option class="text-center" disabled selected>-</option>
                  <option v-for="centro in CentroDeCostoMasivo" :key="centro.id" :value="centro.cenCodigo">
                    {{ centro.cenNombre }}
                  </option>
                </select>
              </div>

              <div class="col-3">
                <label for="">Sub Centro</label>
                <select class="form-control text-center py-1" @change="SubSubCentroDeCostosMasivo($event)" disabled>
                  <option disabled selected>-</option>
                  <option v-for="subCentro in SubCentroDeCostoMasivo" :key="subCentro.id"
                    :value="subCentro.cenSubCentro">
                    {{ subCentro.cenNombre }}
                  </option>
                </select>
              </div>

              <div class="col-3">
                <label for="">Sub Sub Centro</label>
                <select class="form-control text-center py-1" @change="SubSubCentroCostosMandaMasivo($event)" disabled>
                  <option disabled selected>-</option>
                  <option v-for="subCen in SubSubCentroDeCostoMasivo" :key="subCen.id" :value="subCen.cenSubSubCodigo">
                    {{ subCen.cenNombre }}
                  </option>
                </select>
              </div>

              <div class="col-4">
                <label for="">Puesto</label>
                <select class="form-control text-center py-1" @change="PuestoMasivo($event)">
                  <option disabled selected>Seleccionar Opción</option>
                  <option v-for="puestos in puesto" :key="puestos.id" :value="puestos.idPuesto">
                    {{ puestos.ptoNombre }}
                  </option>
                </select>
              </div>

              <div class="col col-2">
                <label class="mx-1" for="">Sueldo</label>

                <input type="text" class="form-control text-center py-1" id="exampleInputEmail1"
                  aria-describedby="emailHelp" v-model="sueldoMasivo" />
              </div>

              <!-- <div class="col">
          <div><label for="">Fecha Inicio</label></div>

          <input
            v-model="fechaIniMasivo"
            class="text-center form-control text-secondary"
            type="date"
          />
        </div> -->

              <div class="col col-3">
                <div class="mx-1">
                  <label for="">Fec. Inicio de Renovación</label>
                </div>

                <input disabled v-model="fechaIniMasivo" class="text-center form-control text-secondary py-1"
                  type="text" />
              </div>

              <div class="col col-3">
                <div class="mx-1">
                  <label for="">Fec. Fin de Renovación</label>
                </div>

                <input v-model="fechaFinMasivo" class="text-center form-control text-secondary py-1" type="date" />
              </div>

              <div class="col container col-4 mt-2">
                <button @click="CargaMasiva" class="btn btn-success w-100 mt-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-save mx-3" viewBox="0 0 16 16">
                    <path
                      d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                  </svg>GENERAR CARGA MASIVA
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card border-info text-left px-3 pb-4 mx-4 mt-3">
      <h4 class="tituloColor mt-2">Filtros de búsqueda:</h4>
      <div class="mx-3 mt-3">
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <b-input class="p-2" id="searchInput1" v-model="Dni" placeholder="BUSCAR POR DOCUMENTO DE IDENTIDAD"
                @input="fetchItems"></b-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <b-input class="p-2" id="searchInput2" v-model="Apellidos" placeholder="BUSCAR POR APELLIDOS"
                @input="fetchApellido"></b-input>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group>
              <b-input class="p-2" id="searchInput2" v-model="SubSubCentro" placeholder="BUSCAR POR SUB SUBCENTRO"
                @input="fetchSubSubCentro"></b-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="row mx-3">
      <div class="col col-3">
        <button class="btn btn-danger border border-2 w-100 mt-4" @click="MarcarTodos">
          MARCAR TODOS
        </button>
      </div>
      <div class="col col-3">
        <button class="btn btn-ligth border border-2 w-100 mt-4" @click="MarcarSSC">
          MARCAR POR SSC
        </button>
      </div>

      <div class="mt-4 py-2 container">
        Total de trabajadores : {{ Items.length }}
      </div>
    </div>

    <div class="mt-2 mx-3 table-responsive">
      <table v-if="primeraTabla" class="table table-bordered">
        <thead>
          <tr class="text-nowrap text-white bg-solimano">
            <th scope="col">ACCION</th>
            <th scope="col">ESTADO</th>
            <th scope="col">DOC. IDENTIDAD</th>
            <th scope="col">NOMBRES</th>
            <th scope="col">CC</th>
            <th scope="col">SCC</th>
            <th scope="col">SUB SUB CENTRO</th>
            <th scope="col">PUESTO</th>
            <th scope="col">SUELDO ACTUAL</th>
            <th scope="col">SUELDO</th>
            <th scope="col">FEC.INI CONTRATO</th>
            <th scope="col">FEC.FIN CONTRATO</th>
            <th scope="col">FEC.INI NUEVO CONTRATO</th>
            <th scope="col">FEC.FIN NUEVO CONTRATO</th>
            <th scope="col">MOTIVO RENOVACION</th>
            <th scope="col">VCTO. DE CONTRATO</th>
            <th scope="col">DIAS TRABAJADOR</th>
            <th scope="col">RECORD TRABAJADORES</th>
          </tr>
        </thead>
        <tbody>
          <tr cl class="text-nowrap" v-for="itema in Items" :key="itema.id">
            <th class="" scope="row">
              <div class="px-4">
                <div class="">
                  <!-- v-if="itema.accionRen == true" -->
                  <!-- disabled -->

                  <input :disabled="checkcitos" @change="actualizarEstado(itema)" type="checkbox"
                    :value="itema.idRenovacion" v-model="itema.accionRen" />
                  <!-- <input
                    v-else
                    @change="actualizarEstado(itema)"
                    type="checkbox"
                    :value="itema.idRenovacion"
                    v-model="checkeId"
                  /> -->
                </div>
              </div>
            </th>

            <td class="">
              <label for="" :class="{
                'text-primary': itema.renCodEstado == 'EN PROCESO',
                'text-warning oscuro': itema.renCodEstado == 'SOLICITADO',
              }">{{ itema.renCodEstado }}</label>
            </td>
            <td class="">{{ itema.nroDocumento }}</td>
            <td class="text-left">
              <label for="" class="px-2">{{ itema.nomTrabajador }}</label>
            </td>
            <td class="">{{ itema.nomEmpresa }}</td>
            <td class="">{{ itema.subCentroCostos }}</td>

            <td>
              <label for="" class="">{{ itema.subSubCentroCostos }}</label>
            </td>

            <td>
              <label for="" class="">{{ itema.nomPuesto }}</label>
            </td>

            <td class="">{{ itema.renSueldoActual }}</td>
            <td class="">
              <div class="form-group">
                <p v-if="
                  sueldoFinal >
                  itema.renSueldoActual * 0.2 + itema.renSueldoActual &&
                  from.idRenovacion == itema.idRenovacion
                ">
                  No puedes exceder el 20% del sueldo Actual
                </p>

                <!-- @change="mostrar($event)"
              :value="data.item.renSueldo" -->

                <label for="" class="py-0">{{ itema.renSueldo }}</label>
              </div>
            </td>

            <td>
              <label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled class="text-center text-black">
                -
              </label>

              <input v-else disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecIniConActual.slice(0, 10)" />
            </td>

            <td class="text-center">
              <input disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecFinConActual.slice(0, 10)" />
            </td>

            <td>
              <input class="text-center form-control text-secondary" disabled @change="FechaIni($event)" type="date"
                :value="itema.fechaIniContrato.slice(0, 10)" />
            </td>

            <td>
              <input disabled class="form-control text-center text-secondary text-center" type="date"
                :value="itema.fechaFinContrato.slice(0, 10)" />
            </td>

            <td class="py-0 my-0">
              <div class="" for="">
                <p class="" v-if="itema.motivoRenovacion.length > 0">
                  {{ itema.motivoRenovacion }}
                </p>
                <p class="my-2" v-else>no hay motivo</p>
              </div>
            </td>

            <td class="">
              <div class="mx-3">
                <label for="" class="text-center">{{ itema.diasRen }} Días</label>
              </div>
            </td>

            <td class="">{{ itema.diasTrabajador }}</td>

            <td class="">
              <div class="form-group w-auto">
                <label for="" class="d-flex text-center">
                  <p class="mx-1" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table v-if="segundaTabla" class="table table-bordered">
        <thead>
          <tr class="text-nowrap text-white bg-solimano">
            <th scope="col">ACCION</th>
            <th scope="col">ESTADO</th>
            <th scope="col">DOC. IDENTIDAD</th>
            <th scope="col">NOMBRES</th>
            <th scope="col">CC</th>
            <th scope="col">SCC</th>
            <th scope="col">SUB SUB CENTRO</th>
            <th scope="col">PUESTO</th>
            <th scope="col">SUELDO ACTUAL</th>
            <th scope="col">SUELDO</th>
            <th scope="col">FEC.INI CONTRATO</th>
            <th scope="col">FEC.FIN CONTRATO</th>
            <th scope="col">FEC.INI NUEVO CONTRATO</th>
            <th scope="col">FEC.FIN NUEVO CONTRATO</th>
            <th scope="col">MOTIVO RENOVACION</th>
            <th scope="col">VCTO. DE CONTRATO</th>
            <th scope="col">DIAS TRABAJADOR</th>
            <th scope="col">RECORD TRABAJADORES</th>
            <!-- <th scope="col">REGISTRAR</th> -->
          </tr>
        </thead>
        <tbody>
          <tr class="text-nowrap" v-for="itema in documentos" :key="itema.id">
            <th class="" scope="row">
              <div class="px-4">
                <input @change="actualizarEstado(itema)" type="checkbox" :value="itema.idRenovacion"
                  v-model="itema.accionRen" />
              </div>
            </th>

            <td class="">
              <label for="" :class="{
                'text-primary': itema.renCodEstado == 'EN PROCESO',
                'text-warning oscuro': itema.renCodEstado == 'SOLICITADO',
              }">{{ itema.renCodEstado }}</label>
            </td>
            <td class="">{{ itema.nroDocumento }}</td>
            <td class="text-left">
              <label for="" class="px-2">{{ itema.nomTrabajador }}</label>
            </td>
            <td class="">{{ itema.nomEmpresa }}</td>
            <td class="">{{ itema.subCentroCostos }}</td>

            <td>
              <select @change="SubSubCentroCostosManda($event)" v-if="itema.accionRen" class="form-control text-center"
                id="exampleFormControlSelect1">
                <option disabled selected>
                  {{ itema.subSubCentroCostos }}
                </option>
                <option v-for="subSubCentro in SubCentroDeCostoMasivo" :key="subSubCentro.id"
                  :value="subSubCentro.cenSubSubCodigo">
                  {{ subSubCentro.cenNombre }}
                </option>
              </select>

              <label for="" class="" v-else>{{
                itema.subSubCentroCostos
              }}</label>
            </td>

            <td>
              <select @change="Puesto($event)" v-if="itema.accionRen" class="form-control text-center"
                id="exampleFormControlSelect1">
                <option disabled selected>{{ itema.nomPuesto }}</option>
                <option v-for="puestos in puesto" :key="puestos.id" :value="puestos.idPuesto">
                  {{ puestos.ptoNombre }}
                </option>
              </select>

              <label for="" class="" v-else>{{ itema.nomPuesto }}</label>
            </td>

            <td class="">{{ itema.renSueldoActual }}</td>
            <td class="">
              <div class="form-group">
                <p v-if="
                  sueldoFinal >
                  itema.renSueldoActual * 0.2 + itema.renSueldoActual &&
                  from.idRenovacion == itema.idRenovacion
                ">
                  No puedes exceder el 20% del sueldo Actual
                </p>

                <input v-if="itema.accionRen" type="text" class="form-control text-center" id="exampleInputEmail1"
                  v-model="sueldoFinal" aria-describedby="emailHelp" />

                <!-- @change="mostrar($event)"
              :value="data.item.renSueldo" -->

                <label for="" class="" v-if="!itema.accionRen">{{
                  itema.renSueldo
                }}</label>
              </div>
            </td>

            <td class="">
              <label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled class="text-center text-black">
                -
              </label>

              <input v-else disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecIniConActual.slice(0, 10)" />
            </td>

            <td class="text-center">
              <input disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecFinConActual.slice(0, 10)" />
            </td>

            <td class="">
              <input v-if="itema.accionRen" disabled class="form-control text-center text-secondary"
                @change="FechaIni($event)" type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
              <input v-if="!itema.accionRen" disabled class="text-center form-control text-secondary"
                @change="FechaIni($event)" type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
            </td>

            <td class="">
              <input v-if="itema.accionRen" class="form-control text-center text-secondary text-center"
                @change="FechaFin($event)" type="date" :value="itema.fechaFinContrato.slice(0, 10)" />
              <input v-if="!itema.accionRen" disabled class="text-center form-control text-secondary"
                @change="FechaFin($event)" type="date" :value="itema.fechaFinContrato.slice(0, 10)" />
            </td>

            <td class="py-0 my-0">
              <div class="" for="">
                <p class="" v-if="itema.motivoRenovacion.length > 0">
                  {{ itema.motivoRenovacion }}
                </p>
                <p class="" v-else>no hay motivo</p>
              </div>
            </td>

            <td class="">
              <div class="mx-3">
                <label for="" class="text-center">{{ itema.diasRen }} Días</label>
              </div>
            </td>

            <td class="">{{ itema.diasTrabajador }}</td>

            <td class="">
              <div class="form-group w-auto">
                <label for="" class="d-flex text-center">
                  <p class="mx-1" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </label>
              </div>
            </td>

            <!-- <td class="">
              <div class="form-group">
                <button
                  :disabled="
                    from.idRenovacion == itema.idRenovacion ||
                    itema.accionRen == true
                      ? false
                      : true
                  "
                  @click="Registro(itema)"
                  class="btn btn-light"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-check-circle text-success"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </button>
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>

      <table v-if="terceraTabla" class="table table-bordered">
        <thead>
          <tr class="text-nowrap text-white bg-solimano">
            <th scope="col">ACCION</th>
            <th scope="col">ESTADO</th>
            <th scope="col">DOC. IDENTIDAD</th>
            <th scope="col">NOMBRES</th>
            <th scope="col">CC</th>
            <th scope="col">SCC</th>
            <th scope="col">SUB SUB CENTRO</th>
            <th scope="col">PUESTO</th>
            <th scope="col">SUELDO ACTUAL</th>
            <th scope="col">SUELDO</th>
            <th scope="col">FEC.INI CONTRATO</th>
            <th scope="col">FEC.FIN CONTRATO</th>
            <th scope="col">FEC.INI NUEVO CONTRATO</th>
            <th scope="col">FEC.FIN NUEVO CONTRATO</th>
            <th scope="col">MOTIVO RENOVACION</th>
            <th scope="col">VCTO. DE CONTRATO</th>
            <th scope="col">DIAS TRABAJADOR</th>
            <th scope="col">RECORD TRABAJADORES</th>
          </tr>
        </thead>
        <tbody>
          <tr cl class="text-nowrap" v-for="itema in documentos" :key="itema.id">
            <th class="" scope="row">
              <div class="px-4">
                <input @change="actualizarEstado(itema)" type="checkbox" :value="itema.idRenovacion"
                  v-model="itema.accionRen" />
              </div>
            </th>

            <td class="">
              <label for="" :class="{
                'text-primary': itema.renCodEstado == 'EN PROCESO',
                'text-warning oscuro': itema.renCodEstado == 'SOLICITADO',
              }">{{ itema.renCodEstado }}</label>
            </td>
            <td class="">{{ itema.nroDocumento }}</td>
            <td class="text-left">
              <label for="" class="px-2">{{ itema.nomTrabajador }}</label>
            </td>
            <td class="">{{ itema.nomEmpresa }}</td>
            <td class="">{{ itema.subCentroCostos }}</td>

            <td>
              <select @change="SubSubCentroCostosManda($event)" v-if="itema.accionRen" class="form-control text-center"
                id="exampleFormControlSelect1">
                <option disabled selected>
                  {{ itema.subSubCentroCostos }}
                </option>
                <option v-for="subSubCentro in SubCentroDeCostoMasivo" :key="subSubCentro.id"
                  :value="subSubCentro.cenSubSubCodigo">
                  {{ subSubCentro.cenNombre }}
                </option>
              </select>

              <label for="" class="" v-else>{{
                itema.subSubCentroCostos
              }}</label>
            </td>

            <td>
              <select @change="Puesto($event)" v-if="itema.accionRen" class="form-control text-center"
                id="exampleFormControlSelect1">
                <option disabled selected>{{ itema.nomPuesto }}</option>
                <option v-for="puestos in puesto" :key="puestos.id" :value="puestos.idPuesto">
                  {{ puestos.ptoNombre }}
                </option>
              </select>

              <label for="" class="" v-else>{{ itema.nomPuesto }}</label>
            </td>

            <td class="">{{ itema.renSueldoActual }}</td>
            <td class="">
              <div class="form-group">
                <p v-if="
                  sueldoFinal >
                  itema.renSueldoActual * 0.2 + itema.renSueldoActual &&
                  from.idRenovacion == itema.idRenovacion
                ">
                  No puedes exceder el 20% del sueldo Actual
                </p>

                <input v-if="itema.accionRen" type="text" class="form-control text-center" id="exampleInputEmail1"
                  v-model="sueldoFinal" aria-describedby="emailHelp" />

                <!-- @change="mostrar($event)"
              :value="data.item.renSueldo" -->

                <label for="" class="" v-if="!itema.accionRen">{{
                  itema.renSueldo
                }}</label>
              </div>
            </td>

            <td>
              <label v-if="itema.fecIniConActual.slice(0, 10) == '1900-01-01'" disabled class="text-center text-black">
                -
              </label>

              <input v-else disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecIniConActual.slice(0, 10)" />
            </td>

            <td class="text-center">
              <input disabled class="form-control text-center text-secondary" type="date"
                :value="itema.fecFinConActual.slice(0, 10)" />
            </td>

            <td>
              <input v-if="itema.accionRen" disabled class="form-control text-center text-secondary"
                @change="FechaIni($event)" type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
              <input v-if="!itema.accionRen" disabled class="text-center form-control text-secondary"
                @change="FechaIni($event)" type="date" :value="itema.fechaIniContrato.slice(0, 10)" />
            </td>

            <td>
              <input v-if="itema.accionRen" class="form-control text-center text-secondary text-center"
                @change="FechaFin($event)" type="date" :value="itema.fechaFinContrato.slice(0, 10)" />
              <input v-if="!itema.accionRen" disabled class="text-center form-control text-secondary"
                @change="FechaFin($event)" type="date" :value="itema.fechaFinContrato.slice(0, 10)" />
            </td>

            <td>
              <div class="" for="">
                <p class="mb-0" v-if="itema.motivoRenovacion.length > 0">
                  {{ itema.motivoRenovacion }}
                </p>
                <p class="mb-0" v-else>no hay motivo</p>
              </div>
            </td>

            <td class="">
              <div class="mx-3">
                <label for="" class="text-center">{{ itema.diasRen }} Días</label>
              </div>
            </td>

            <td class="">{{ itema.diasTrabajador }}</td>

            <td class="">
              <div class="form-group w-auto">
                <label for="" class="d-flex text-center">
                  <p class="mx-1" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-2" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} días
                  </p>
                  <p class="mx-2" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} días
                  </p>
                </label>
              </div>
            </td>

            <!-- <td class="">
              <div class="form-group">
                <button
                  :disabled="
                    from.idRenovacion == itema.idRenovacion ||
                    itema.accionRen == true
                      ? false
                      : true
                  "
                  @click="Registro(itema)"
                  class="btn btn-light"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    class="bi bi-check-circle text-success"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                    />
                    <path
                      d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"
                    />
                  </svg>
                </button>
              </div>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SolimanologRegistroDeCeseMasivo",

  data() {
    return {
      primeraTabla: true,
      segundaTabla: false,
      terceraTabla: false,
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      sueldoFinal: "",
      Totalkit: [],
      TotalSsc: [],
      excelCarga: false,
      excel: [],
      documentos: [],
      // fechaFinRen:[],
      checkcitos: false,

      from: {
        idRenovacion: "",
      },
      filter: "",
      filtradoAntes: "",
      perPage: 10,
      totalRows: 1,
      currentPage: 1,
      checkeId: [],
      puesto: [],
      dniUsuario: "",
      CentroDeCostoMasivo: [],
      SubCentroDeCostoMasivo: [],
      idEmpresaMasivo: [],
      SubSubCentroDeCostoMasivo: [],
      cenCodigoCentroMasivo: "",
      cenCodigoSubCentroMasivo: "",
      cenCodigoSubSubCemtroMasivo: "",
      idPuestoMasivo: "0",
      sueldoMasivo: "0",
      fechaIniMasivo: "-",
      fechaFinMasivo: "",
      colorRenovacion: "",
    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.totalRows = this.Items.length;
    this.axios.get("ParametroData/Parametro/7634").then((r) => {
      console.log(r.data);
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      console.log(r.data);
      this.puesto = r.data;
    });
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),
    ...mapGetters("renovaciones", ["Items"]),
  },
  created() {
    // this.IntegrarIds();
    this.reporteRenovacion();
  },
  methods: {
    ...mapActions("renovaciones", ["Renovaciones"]),

    reporteRenovacion() {
      console.log("aja");
      this.idTrabajador = localStorage.getItem("idTrabajdor");

      this.excelCarga = false;
      this.axios
        .get(
          `ReportesExcel/RepRenovacioness?idTrabajador=${this.idTrabajador}`,
          { responseType: "blob" }
        )
        .then((response) => {
          this.excelCarga = true;
          this.excel = response.data;
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteRenovaciones.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    IntegrarIds() {
      console.log(this.Items);
      for (let index of this.Items) {
        if (index.accionRen == true) {
          this.Totalkit.push(index.idRen);
          console.log(this.Totalkit);
        }
      }
    },
    MarcarTodos() {
      const cadenaMasiva = [];
      this.Items.map((r) => {
        console.log(r.idRenovacion);
        cadenaMasiva.push(r.idRenovacion);
      });

      const from = {
        idRenovaciones: `${cadenaMasiva}`,
      };

      console.log(from);
      this.axios.put(`Renovacion/CambioEstadoGeneral`, from).then((r) => {
        console.log(r.data);
        this.Renovaciones();
      });
    },

    quitarCampos() {
      // const from = { cadenaRenovacion: `${this.Totalkit}` };
      // this.axios.put("Renovacion/EstadosMasivos", from).then((r) => {
      //   console.log(r.data);
      //   this.Renovaciones();
      // });
      // this.checkcitos = !this.checkcitos
      console.log("hola");
    },

    CargaTrabajadores() {
      const usuario = localStorage.getItem("userId");
      this.axios
        .get(`Renovacion/CanTrabajadores?idUsuario=${usuario}`)
        .then((r) => {
          if (r.status == 200) {
            this.reporteRenovacion();
            if (r.data.canTrabajadores == "0") {
              Swal.fire(`No se cargo ningún trabajador`, "", "success");
            } else if (r.data.canTrabajadores == "1") {
              Swal.fire(
                `Se registro ${r.data.canTrabajadores}  trabajador`,
                "",
                "success"
              );
            } else {
              Swal.fire(
                `Se registraron ${r.data.canTrabajadores}  trabajadores`,
                "",
                "success"
              );
            }
          }

          this.Renovaciones();
        });
    },

    fetchItems() {
      console.log(this.Dni.length);

      if (this.Dni.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.terceraTabla = false;
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDni?NroDocumento=${this.Dni}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.terceraTabla = false;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchApellido() {
      console.log(this.Apellidos.length);
      this.documentos = [];
      if (this.Apellidos.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.terceraTabla = false;
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxApellido?Apellido=${this.Apellidos}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.terceraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchSubSubCentro() {
      this.documentos = [];
      if (this.SubSubCentro.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.terceraTabla = false;
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxSubSubCc?cuenta=${this.SubSubCentro}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = false;
              this.terceraTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    MarcarSSC() {
      this.documentos.map((r) => {
        if (!r.accionRen) {
          this.TotalSsc.push(r.idRenovacion);
        }
      });

      const from = {
        idRenovaciones: `${this.TotalSsc}`,
      };

      console.log(from);
      this.axios.put(`Renovacion/CambioEstadoGeneral`, from).then((r) => {
        console.log(r.data);
        this.SubSubCentro = "";
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.terceraTabla = false;

        this.Renovaciones();
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filtro() {
      this.filter = this.filtradoAntes;
    },

    CentroCostoMasivo(event) {
      this.idEmpresaMasivo = event.target.value;
      this.axios
        .get(
          `Ccosto/CentroxTrabajador?idEmpresa=${event.target.value}&dniUser=${this.dniUsuario}`
        )
        .then((r) => {
          this.CentroDeCostoMasivo = r.data;
          console.log(r.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    SubCentroCostoMasivo(event) {
      this.cenCodigoCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubCentro/SubCxTrabajador?codCenCosto=${event.target.value}&dniUser=${this.dniUsuario}&idEmpresa=${this.idEmpresaMasivo}`
        )
        .then((r) => {
          this.SubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroDeCostosMasivo(event) {
      this.cenCodigoSubCentroMasivo = event.target.value;
      console.log(event.target.value);
      this.axios
        .get(
          `SubSubCentro/SScxTrabajador?idEmpresa=${this.idEmpresaMasivo}&dniUser=${this.dniUsuario}&codCentro=${this.cenCodigoCentroMasivo}&codSubCentro=${event.target.value}`
        )
        .then((r) => {
          this.SubSubCentroDeCostoMasivo = r.data;
          console.log(r.data);
        });
    },

    SubSubCentroCostosMandaMasivo(event) {
      this.cenCodigoSubSubCemtroMasivo = event.target.value;
      console.log(event.target.value);
    },

    PuestoMasivo(event) {
      this.idPuestoMasivo = event.target.value;
      console.log(event.target.value);
    },

    CargaMasiva() {
      this.Items.map((respuesta) => {
        // console.log(respuesta.fechaIniContrato)
        if (respuesta.accionRen == true) {
          this.Totalkit.push(respuesta.idRen);
          // this.fechaFinRen.push(respuesta.fechaIniContrato)
        }
      });

      console.log(this.Totalkit);
      // const from = {
      //   cadenaRenovacion: `${this.Totalkit}`,
      //   idEmpresa: this.idEmpresaMasivo,
      //   renCodCC: this.cenCodigoCentroMasivo,
      //   renCodScc: this.cenCodigoSubCentroMasivo,
      //   renCodSscc: this.cenCodigoSubSubCemtroMasivo,
      //   idPuesto: this.idPuestoMasivo,
      //   renSueldo: this.sueldoMasivo,
      //   fechaIniContrato: this.fechaIniMasivo,
      //   fechaFinContrato: this.fechaFinMasivo,
      // };

      const from = {
        cadenaRenovacion: `${this.Totalkit}`,
        idEmpresa: 0,
        renCodCC: "",
        renCodScc: "",
        renCodSscc: "",
        idPuesto: this.idPuestoMasivo,
        renSueldo: this.sueldoMasivo,
        fechaFinContrato: this.fechaFinMasivo,
      };
      // fechaIniContrato: this.fechaIniMasivo,

      console.log(from);

      this.axios.put("/Renovacion/ModificarRenMasivo", from).then((r) => {
        console.log(r.data);
        if (r.data == true) {
          this.Renovaciones();
          this.Totalkit = [];
          Swal.fire(`Se Renovaron los trabajadores`, "", "success");
        }
      });
    },
    actualizarEstado(items) {
      console.log(items.accionRen);
      this.from.idRenovacion = items.idRenovacion;
      if (items.accionRen == true) {
        this.colorRenovacion = items.idRenovacion;
      } else {
        this.colorRenovacion = "";
      }

      this.axios.put("Renovacion/ModificarAccionxRen", this.from).then((r) => {
        console.log(r);
      });
    },
  },
};
</script>

<style scoped>
select {
  margin-top: 0px;
  padding: 0px;
}

label {
  padding: 0px;
}

input[type="checkbox"] {
  padding: 0px;
  height: auto;
}

input[type="date"] {
  padding: 0px;
  height: auto;
}

input[type="text"] {
  min-width: 150px;
  padding: 0px;
}

/* .table,
thead,
tr {
  background: #0080c8;
  text-align: justify;
} */

.text-left {
  text-align: left;
}

/* select {
  min-width: 60px;
  padding-right: 5px;
  text-align: center;
} */

.bg-solimano {
  background: #0080c8;
}

.texto-color {
  color: #002c5d;
  font-size: 2.155rem;
  font-weight: 700;
}

.oscuro {
  font-weight: 700;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}
</style>
